import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import se from '../locales/se.json';
import dk from '../locales/dk.json';
import no from '../locales/no.json';
import fi from '../locales/fi.json';
import is from '../locales/is.json';

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    lng: 'en',
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: en },
      se: { translation: se },
      dk: { translation: dk },
      no: { translation: no },
      fi: { translation: fi },
      is: { translation: is },
    },
  });

export const getSupportedLanguages = () => ['en', 'se', 'dk', 'no', 'fi', 'is'];

export default i18n;